module.exports = __webpack_public_path__ + "static/media/Banner_Blockchain.9f544751.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Curso_img/splint/Banner_Blockchain.png
// module id = 48
// module chunks = 0